<template>
  <div>
    <div v-loading="is_loading">
      <HeaderSteps :title="campaign?.name" :dialog="false" :back-path="{ name: 'social-boost' }">
        <div slot="status">
          <CampaignStatus :status="flight?.status" />
        </div>

        <template slot="action-menu">
          <TblAction :campaign="campaign" :index="0" redirectTo="social-boost" :circle="true" :is-header="true" />
        </template>

        <template slot="tabs">
          <div class="flex items-center justify-center gap-1">
            <RouterLink :to="{ name: 'campaign-flight-assets' }" class="menuItem"> Assets </RouterLink>
            <RouterLink :to="{ name: 'campaign-flight-creatives' }" class="menuItem"> Creatives </RouterLink>
            <RouterLink :to="{ name: 'campaign-flight-screenshots' }" class="menuItem"> Screenshots </RouterLink>
            <RouterLink :to="{ name: 'campaign-flight-notes' }" class="menuItem"> Notes </RouterLink>
            <RouterLink :to="{ name: 'campaign-flight-reports' }" class="menuItem"> Reports </RouterLink>
            <RouterLink :to="{ name: 'campaign-flight-activity' }" class="menuItem"> Activity </RouterLink>
            <RouterLink :to="{ name: 'campaign-flight-analytics' }" class="menuItem"> Analytics </RouterLink>
          </div>
        </template>
        <template slot="actions">
          <CtaHeaderActions :campaign="campaign" />
        </template>
      </HeaderSteps>
      <div class="flex flex-wrap Page__scrollable-content">
        <!-- summary col -->
        <div class="w-1/5 sticky top-0 h-full">
          <Summary />
        </div>
        <!-- end summary col -->
        <!-- content col -->
        <div class="w-4/5 py-3">
          <RevisionRequested v-if="$SBCampaignStatusAccess(['revision'], flightStatus)" :comment="revisionReqDetails" />
          <div class="w-full pr-3">
            <RouterView class="Campaigns--child Loading__target h-full" />
          </div>
        </div>
        <!-- end content col -->
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import HeaderSteps from '@/components/social-products/social-boost/parts/HeaderSteps.vue'
import CampaignStatus from '@/components/social-products/social-boost/parts/CampaignStatus.vue'
import Summary from '@/components/social-products/social-boost/parts/Summary.vue'
import CtaHeaderActions from '@/components/social-products/social-boost/parts/CtaHeaderActions.vue'
import TblAction from '@/components/social-products/social-boost/parts/table/TableAction.vue'
import RevisionRequested from '@/components/social-products/social-boost/parts/RevisionRequested.vue'
import ClearDataMixin from '@/mixins/social-products/ClearData.js'

export default {
  mixins: [ClearDataMixin],
  components: {
    HeaderSteps,
    CampaignStatus,
    Summary,
    CtaHeaderActions,
    TblAction,
    RevisionRequested,
  },
  data() {
    return {
      summaryData: {},
      isLoading: false,
    }
  },
  created() {
    this.init()
  },
  computed: {
    ...mapGetters('socialBoostCampaign', ['campaign']),
    ...mapGetters('app', ['is_loading']),
    flight() {
      return this.campaign?.flights?.find((f) => f.id === Number(this.$route.params.flight_id))
    },
    flightStatus() {
      return this.flight?.status
    },
    revisionReqDetails() {
      return this.flight?.revision_requested_details?.comment || false
    },
  },
  methods: {
    async init() {
      this.isLoading = true
      await this.$store.dispatch('socialBoostCampaign/getCampaign', { id: this.$route.params.id })
      this.isLoading = false
    },
  },
}
</script>
<style lang="scss" scoped>
.menuItem {
  @apply text-dark font-bold border-b-2 border-transparent px-2 py-1 hover:text-primary;
  &.router-link-active {
    @apply border-primary text-primary;
  }
}
</style>
